const showImage = (el) => {
  const targetId = el.dataset.hoverImage;
  const target = document.querySelector(`[data-hover-target="${targetId}"]`);

  target.classList.remove('max-h-0');
  target.classList.add('opacity-100');

  el.addEventListener('mouseleave', () => {
    target.classList.remove('opacity-100');
    setTimeout(() => {
      // Do not hide if it's still mouseover
      if (el.matches(':hover')) {
        return;
      }
      target.classList.add('max-h-0');
    }, 1000);
  });
};

const init = () => {
  const table = document.getElementById('js-projects-table-body');
  if (table) {
    table.addEventListener('mouseover', () => {
      const imageHovers = document.querySelectorAll('[data-hover-image]');
      imageHovers.forEach((imageHover) => {
        imageHover.addEventListener('mouseover', () => {
          showImage(imageHover);
        });
      });
    });
  }
};

export default {
  init,
};
